module.exports = __webpack_public_path__ + "static/media/triangle.0c920a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/triangle.png
// module id = 675
// module chunks = 0